export function unique<TEntity = unknown>(args: List<TEntity>): List<TEntity> {
  return Array.from(new Set([...args]));
}
